import React from 'react';
import styles from './SideBar.module.css';
import logo from '../../../Assets/Alphalogo.png';

const LogoSection = ({ isOpen, portalInfo }) => {
    return (
        <div className={styles.logoSection}>
            <div className={styles.logoWrapper}>
                {isOpen && (
                    <div >
                        <img src={logo} alt="AlphaMD Logo" className={styles.logoImage} /><br/>    
                        <div className={styles.logoText}>                        
                        <span className={styles.logoTitle}>{portalInfo.title}</span>
                        <span className={styles.logoSubtitle}>{portalInfo.subtitle}</span>
                    </div>                   
                    </div>
                    
                )}
            </div>
        </div>
    );
};

export default LogoSection;